import PropTypes from 'prop-types';
import { Cushion, Rectangle, Shadow, Typography } from '@pitchero/react-ui';
import React from 'react';
import { Trans } from '../../lib/i18n';

const TrainingDetails = ({ description, venue }) => (
  <Shadow>
    <Rectangle fill="white" radius="rounded">
      <Cushion
        className="training-details"
        all="large"
        style={{ gridArea: 'details' }}
        component="div"
      >
        <Typography preset="tab--active" component="h2">
          <Trans i18nKey="common:training_venue">Location</Trans>
        </Typography>
        <Typography preset="body--large" component="p">
          {venue}
        </Typography>
        <Typography preset="tab--active" component="h2">
          <Trans i18nKey="common:training_description">Description</Trans>
        </Typography>
        <Typography preset="body--large" component="p">
          {description}
        </Typography>
      </Cushion>
    </Rectangle>
  </Shadow>
);

TrainingDetails.propTypes = {
  description: PropTypes.string.isRequired,
  venue: PropTypes.string.isRequired,
};

export default TrainingDetails;
